/**
 * useFeatureRecommendation — fetches the upsell payload for a single
 * gated feature: catalog label + cheapest plan/addon/pack that unlock
 * it. Shared by ``LockedPage`` and ``LockedSection`` so every locked
 * surface in the app speaks the same upgrade vocabulary.
 *
 * Endpoint: ``GET /api/billing/feature-recommendation/<feature_key>``.
 * Auth-required. Cache 5 min — pricing rarely changes mid-session.
 */
import { useQuery } from "@tanstack/react-query";
import { api } from "../lib/api";

export function useFeatureRecommendation(featureKey) {
  return useQuery({
    queryKey: ["feature-recommendation", featureKey],
    queryFn: async () => (await api.get(`/billing/feature-recommendation/${featureKey}`)).data,
    enabled: !!featureKey,
    staleTime: 5 * 60_000,
    retry: false,
  });
}
